import { GameStats } from "@/components/GameStats";
import { useUserContext } from "@/contexts/user";
import { useStatsContext } from "@/contexts/stats";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabase/client";
import { useEffect } from "react";
import { useCompletedSectionCount } from "@/contexts/appContent/appContentHooks";

export type Stats = {
    completedSectionCount: number;
    averageCheckinScore: number;
    dailyStreak: number;
};

export function StatsSection() {
    const { stats, setStats } = useStatsContext();
    const { user } = useUserContext();
    const { toast } = useToast();
    const completedSectionCount = useCompletedSectionCount();

    // TODO: These effects should be moved into the stats hook

    useEffect(() => {
        (async () => {
            const { data, error } = await supabase.from("last_checkin_avg").select("avg_rating").eq("user_id", user.id).limit(1);
            if (error) {
                console.error(error);
                return;
            }
            setStats(prev => ({
                ...prev,
                averageCheckinScore: data[0]?.avg_rating
            }));
        })();
    }, [setStats, user?.id]);

    useEffect(() => {
        (async () => {
            const { data, error } = await supabase.from("completed_section_total_counts").select("count").eq("user_id", user.id).limit(1);
            if (error) {
                toast({
                    title: "Lyckades inte hämta dina gnistor",
                    description: "Vänligen försök igen senare",
                    variant: "destructive"
                });
                console.error(error);
                return;
            }
            setStats(prev => ({ ...prev, completedSectionCount: data?.[0]?.count ?? 0 }));
        })();
    }, [user.id, toast, setStats]);

    useEffect(() => {
        setStats(prev => ({ ...prev, completedSectionCount: completedSectionCount > prev.completedSectionCount ? completedSectionCount : prev.completedSectionCount }));
    }, [completedSectionCount, setStats]);

    return (
        <section className="py-16 bg-muted/30">
            <div className="container mx-auto px-6">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold mb-4 text-foreground">
                        Din progress
                    </h2>
                    <p className="text-muted-foreground">
                        Skapa din inre glöd och se hur du utvecklas
                    </p>
                </div>
                {/* TODO: Don't hardcode the 26 */}
                <GameStats
                    balance={Math.round(stats.averageCheckinScore)}
                    sparkles={`${stats.completedSectionCount}/26`}
                    dailyStreak={stats.dailyStreak}
                />
            </div>
        </section>
    );
}